import { CALL_API } from "../../middlewares/api";

export const SALE_TERMINATED_LOANS_FETCH_REQUEST =
  "SALE_TERMINATED_LOANS_FETCH_REQUEST";
export const SALE_TERMINATED_LOANS_FETCH_SUCCESS =
  "SALE_TERMINATED_LOANS_FETCH_SUCCESS";
export const SALE_TERMINATED_LOANS_FETCH_ERROR =
  "SALE_TERMINATED_LOANS_FETCH_ERROR";

export function get_terminated_loans() {
  return {
    [CALL_API]: {
      method: "GET",
      endpoint: "/api/admin/debt-agency/loans-suggested-for-da-sale",
      authenticatedRequest: true,
      types: [
        SALE_TERMINATED_LOANS_FETCH_REQUEST,
        SALE_TERMINATED_LOANS_FETCH_SUCCESS,
        SALE_TERMINATED_LOANS_FETCH_ERROR,
      ],
    },
  };
}
